<template>
  <div class="landing" :class="'theme-' + theme">
    <!-- Navigation -->
    <nav class="nav">
      <div class="nav-inner">
        <div class="nav-left">
          <el-image class="nav-logo" style="width: 40px;height: 40px;"
            :src="require('@/assets/img/qhy2.png')"></el-image>
          <span class="nav-name">{{ $siteConfig.siteName }}</span>
        </div>
        <div class="nav-center">
          <a class="nav-link nav-link-active" href="#">功能</a>
          <a class="nav-link" href="javascript:;" @click="$router.push('/user/buyvip')">价格</a>
          <a class="nav-link" href="#">关于我们</a>
        </div>
        <div class="nav-right">
          <button class="theme-toggle" :title="theme === 'light' ? '切换深色主题' : '切换浅色主题'"
            @click="toggleTheme">
            <i :class="theme === 'light' ? 'el-icon-moon' : 'el-icon-sunny'"></i>
          </button>
          <button class="btn-text" @click="$router.push('/register')">注册</button>
          <button class="btn-primary" @click="goWebLogin">{{ loggedIn ? '进入工作台' : '登录' }}</button>
        </div>
      </div>
    </nav>

    <!-- Hero -->
    <section class="hero">
      <div class="hero-bg">
        <div ref="particles" class="particles"></div>
        <div class="blob blob-1"></div>
        <div class="blob blob-2"></div>
        <div class="blob blob-3"></div>
        <div class="blob blob-4"></div>
      </div>
      <div class="hero-content">
        <div class="hero-card">
          <div class="hero-badge">
            <i class="el-icon-circle-check hero-badge-icon"></i>
            <span>5年专业运营智能剪辑工具</span>
          </div>
          <h1 class="hero-title">
            <span class="hero-title-top">一键！</span>
            <div class="hero-title-rotate">
              <div ref="scrollText" class="scroll-text">
                <span>智能视频创作平台</span>
                <span>视频混剪操作</span>
                <span>好物素材生成</span>
                <span>智能视频创作平台</span>
              </div>
            </div>
          </h1>
          <p class="hero-desc">
            为您提供视频去重、智能混剪及海量好物素材，<br class="hide-mobile">让剪辑更高效、更专业。
          </p>
          <div class="hero-actions">
            <button class="btn-start" @click="goWebLogin">
              网页版登录
              <i class="el-icon-right btn-icon"></i>
            </button>
            <div class="app-download-action">
              <button class="btn-app-download" @click="goAppDownload">
                <span class="app-download-mark">
                  <i class="el-icon-mobile-phone"></i>
                </span>
                <span class="app-download-copy">
                  <strong>手机端APP下载</strong>
                  <small>支持 iOS / Android 使用</small>
                </span>
                <i class="el-icon-arrow-right app-download-arrow"></i>
              </button>
            </div>
          </div>


          <div class="marquee-wrap">
            <div class="marquee-track">
              <div class="marquee-row" v-for="(row, ri) in 2" :key="ri">
                <div v-for="(item, i) in marqueeItems" :key="i" class="marquee-card">
                  <i :class="[item.icon, 'marquee-icon']"></i>
                  <h4 class="marquee-label">{{ item.label }}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Core Features -->
    <section class="section section-features">
      <div class="section-inner">
        <div class="section-header">
          <div class="section-header-text">
            <h2 class="section-title">赋能您的创意流程</h2>
            <p class="section-desc">通过尖端AI技术与直观的工业级设计，我们将复杂的后期制作简化为几次点击。</p>
          </div>
          <div class="section-divider"></div>
        </div>
        <div class="features-grid">
          <div v-for="(feature, i) in features" :key="i" class="feature-card"
            :class="{ 'feature-card-raised': i === 1 }">
            <div class="feature-icon-wrap" :class="`feature-icon-${i}`">
              <i :class="[feature.icon, 'feature-icon']"></i>
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-desc">{{ feature.desc }}</p>
            <ul class="feature-list">
              <li v-for="(item, j) in feature.items" :key="j" class="feature-list-item">
                <i class="el-icon-circle-check feature-check"></i>
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- Tech/Bento -->
    <section class="section section-bento">
      <div class="section-inner">
        <div class="bento-grid">
          <div class="bento-card bento-card-large">
            <div class="bento-content">
              <h3 class="bento-title">工业级工作流</h3>
              <p class="bento-desc">专为追求高产出的专业创作者设计，整合了所有必需的数字化工具。</p>
            </div>
            <div class="bento-terminal">
              <div class="terminal-dots">
                <span class="dot-red"></span>
                <span class="dot-yellow"></span>
                <span class="dot-green"></span>
              </div>
              <div class="terminal-lines">
                <div class="line line-w75"></div>
                <div class="line line-w50"></div>
                <div class="line line-w83"></div>
              </div>
            </div>
            <div class="bento-glow"></div>
          </div>
          <div class="bento-stats">
            <div class="stat-item">
              <div class="stat-value">99%</div>
              <div class="stat-label">处理成功率</div>
            </div>
            <div class="stat-divider"></div>
            <div class="stat-item">
              <div class="stat-value">10x</div>
              <div class="stat-label">创作效率提升</div>
            </div>
          </div>
          <div class="bento-card bento-card-sm">
            <i class="el-icon-upload-success bento-sm-icon"></i>
            <h5 class="bento-sm-title">云端同步</h5>
          </div>
          <div class="bento-card bento-card-sm">
            <i class="el-icon-lock bento-sm-icon"></i>
            <h5 class="bento-sm-title">数据安全</h5>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA -->
    <section class="section">
      <div class="section-inner">
        <div class="cta-card">
          <div class="cta-pattern"></div>
          <h2 class="cta-title">准备好提升您的视频生产力了吗？</h2>
          <p class="cta-desc">加入成千上万位专业创作者的行列，使用{{ $siteConfig.siteName }}开启您的智能创作之旅。</p>
          <button class="btn-white" @click="goWebLogin">立即开始免费体验</button>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <footer class="footer">
      <div class="footer-inner">
        <div class="footer-col footer-brand">
          <div class="footer-logo-row">
            <el-image style="width: 32px;height: 32px;" :src="require('@/assets/img/qhy2.png')"></el-image>
            <span class="footer-name">{{ $siteConfig.siteName }}</span>
          </div>
          <p class="footer-copyright">© 2024 {{ $siteConfig.siteName }} - 专业级智能视频创作平台</p>
          <p style="color: var(--c-slate-400);font-size: 12px;margin: 4px 0 0 0;font-family: var(--font-label);">
            太原多合科技有限公司</p>
          <a
            class="footer-icp"
            href="https://icplishi.com/%E6%99%8BICP%E5%A4%872025070356%E5%8F%B7-3/"
            target="_blank"
            rel="noopener noreferrer"
          >晋ICP备2025070356号-3</a>
        </div>
        <div class="footer-col">
          <h6 class="footer-col-title">产品</h6>
          <a class="footer-link" href="#">功能</a>
          <a class="footer-link" href="#">素材库</a>
          <a class="footer-link" href="#">价格</a>
          <p class="footer-product-note">
            <a class="footer-product-link" href="javascript:;" @click="goAppDownload">多合剪辑 App</a>
            <span> · 起号云配套移动端应用</span>
          </p>
        </div>
        <div class="footer-col">
          <h6 class="footer-col-title">公司</h6>
          <a class="footer-link" href="#">关于我们</a>
          <a class="footer-link" href="#">联系我们</a>
          <a class="footer-link" href="#">帮助中心</a>
        </div>
        <div class="footer-col">
          <h6 class="footer-col-title">法律</h6>
          <a class="footer-link" href="#">隐私政策</a>
          <a class="footer-link" href="#">服务条款</a>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      theme: window.localStorage.getItem('landing_theme') === 'dark' ? 'dark' : 'light',
      loggedIn: false,
      marqueeItems: [
        { icon: 'el-icon-magic-stick', label: '视频去重' },
        { icon: 'el-icon-video-camera', label: '视频混剪' },
        { icon: 'el-icon-goods', label: '好物素材库' },
        { icon: 'el-icon-picture-outline', label: '图片去水印' },
        { icon: 'el-icon-picture', label: 'Ai图片生成' },
        { icon: 'el-icon-headset', label: '真人配音' },
      ],
      features: [
        {
          icon: 'el-icon-magic-stick',
          title: '视频去重',
          desc: '智能识别重复帧，一键清理冗余，确保视频唯一性，显著提升账号权重与审核通过率。',
          items: ['帧级别精准比对', '批量处理能力'],
        },
        {
          icon: 'el-icon-video-camera',
          title: '视频混剪',
          desc: '强大的自动化混剪引擎，多素材智能拼接，通过算法优化节奏与衔接，创作无限可能。',
          items: ['AI节奏匹配', '自适应转场特效'],
        },
        {
          icon: 'el-icon-goods',
          title: '好物素材',
          desc: '实时更新的高质量带货素材库，涵盖全品类热门单品，全方位助力您的内容在社媒平台爆火。',
          items: ['高清品质', '独家带货脚本'],
        },
      ],
    }
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === 'light' ? 'dark' : 'light'
      window.localStorage.setItem('landing_theme', this.theme)
    },
    // 已登录直接进 2.0 工作台，未登录才去登录页
    goWebLogin() {
      if (window.localStorage.getItem('token')) {
        this.$router.push('/user2/index')
      } else {
        this.$router.push('/login')
      }
    },
    goAppDownload() {
      this.$router.push('/duohe-app')
    },
    createParticles() {
      const container = this.$refs.particles
      if (!container) return
      for (let i = 0; i < 20; i++) {
        const p = document.createElement('div')
        p.className = 'particle-dot'
        const size = Math.random() * 4 + 1
        p.style.cssText = `width:${size}px;height:${size}px;left:${Math.random() * 100}%;top:${Math.random() * 100}%`
        p.animate([
          { transform: 'translateY(0) translateX(0)', opacity: 0.1 },
          { transform: `translateY(-${Math.random() * 100}px) translateX(${Math.random() * 50 - 25}px)`, opacity: 0.3 },
          { transform: 'translateY(0) translateX(0)', opacity: 0.1 },
        ], { duration: (Math.random() * 10 + 10) * 1000, iterations: Infinity, delay: Math.random() * 5 * 1000, easing: 'linear' })
        container.appendChild(p)
      }
      this.initScrollReveal()
    },
    initScrollReveal() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-visible')
            entry.target.classList.remove('reveal-hidden')
          }
        })
      }, { threshold: 0.1 })
      document.querySelectorAll('.feature-card, .bento-card, .bento-stats, .bento-card-sm, .hero-card').forEach(el => {
        el.classList.add('reveal-hidden')
        observer.observe(el)
      })
    },
  },
  mounted() {
    this.loggedIn = !!window.localStorage.getItem('token')
    this.createParticles()
  },
  beforeCreate() {
    var upid = window.sessionStorage.getItem('upid')
    if (upid) {
      this.$router.push({ query: { upid, s: upid } })
    }
    if (this.$route.query.upid) {
      window.sessionStorage.setItem('upid', this.$route.query.upid)
    }
    if (this.$route.hash && this.$route.hash.indexOf('#') !== -1) {
      const match = this.$route.hash.match(/[?&]s=([^&]+)/)
      var upid2 = match ? decodeURIComponent(match[1]) : undefined
      if (upid2) window.sessionStorage.setItem('upid', upid2)
      this.$router.push('/shareapp?s=' + upid2)
    }
  },
}
</script>

<style scoped>
/* ===== Design Tokens ===== */
.landing {
  --c-primary: #003ec7;
  --c-primary-container: #0052ff;
  --c-primary-fixed-dim: #b7c4ff;
  --c-primary-fixed: #dde1ff;
  --c-error: #ba1a1a;
  --c-slate-300: #cbd5e1;
  --c-slate-400: #94a3b8;
  --c-white: #ffffff;
  --c-deep: #050a1f;
  --c-mid: #0a1128;
  --c-dark: #020617;
  --font-heading: 'Hanken Grotesk', sans-serif;
  --font-body: 'Inter', sans-serif;
  --font-label: 'Geist', sans-serif;
  --space-xs: 4px;
  --space-base: 8px;
  --space-sm: 12px;
  --space-md: 24px;
  --space-lg: 48px;
  --space-xl: 80px;
  --space-gutter: 24px;
  --space-margin: 32px;
  background: var(--c-deep);
  color: var(--c-white);
  overflow-x: hidden;
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
  transition: background-color 0.3s, color 0.3s;
}

.landing.theme-light {
  background: #f3f6fb;
  color: #172033;
}

/* ===== Reveal ===== */
.reveal-hidden {
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.7s ease;
}

.reveal-visible {
  opacity: 1;
  transform: translateY(0);
}

/* ===== Navigation ===== */
.nav {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 50;
  background: rgba(2, 6, 23, 0.7);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.nav-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--space-margin);
  height: 64px;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: var(--space-base);
}

.nav-logo {
  height: 40px;
  width: 40px;
  object-fit: contain;
}

.nav-name {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 700;
  color: var(--c-white);
}

.nav-center {
  display: none;
}

.nav-link {
  color: var(--c-slate-300);
  font-family: var(--font-body);
  font-size: 16px;
  text-decoration: none;
  transition: color 0.2s;
}

.nav-link:hover {
  color: var(--c-white);
}

.nav-link-active {
  color: var(--c-white);
  font-weight: 600;
  border-bottom: 2px solid var(--c-primary-container);
  padding-bottom: 1px;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: var(--space-md);
}

.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  color: var(--c-slate-300);
  font-size: 17px;
  cursor: pointer;
  transition: all 0.2s;
}

.theme-toggle:hover {
  border-color: rgba(183, 196, 255, 0.55);
  color: var(--c-white);
  transform: translateY(-1px);
}

.btn-text {
  background: none;
  border: none;
  color: var(--c-slate-300);
  font-family: var(--font-label);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: color 0.2s;
}

.btn-text:hover {
  color: var(--c-white);
}

.btn-primary {
  background: var(--c-primary-container);
  color: var(--c-white);
  border: none;
  padding: var(--space-sm) var(--space-lg);
  border-radius: 8px;
  font-family: var(--font-label);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.05em;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-primary:hover {
  filter: brightness(1.1);
}

.btn-primary:active {
  transform: scale(0.95);
}

@media (min-width: 768px) {
  .nav-center {
    display: flex;
    align-items: center;
    gap: var(--space-lg);
  }
}

/* ===== Hero ===== */
.hero {
  position: relative;
  min-height: auto;
  padding-top: 60px;
  padding-bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  background: #020617;
}

.particles {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.particle-dot {
  position: absolute;
  background: #4cc9f0;
  border-radius: 50%;
  opacity: 0.3;
  pointer-events: none;
}

.blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.5;
  animation: blobMove 25s infinite alternate ease-in-out;
}

.blob-1 {
  background: #001d3d;
  width: 800px;
  height: 800px;
  top: -160px;
  left: -160px;
  animation-delay: 0s;
}

.blob-2 {
  background: #003566;
  width: 700px;
  height: 700px;
  bottom: 0;
  right: 0;
  animation-delay: -5s;
}

.blob-3 {
  background: #000814;
  width: 600px;
  height: 600px;
  top: 25%;
  right: 25%;
  animation-delay: -10s;
}

.blob-4 {
  background: #4361ee;
  width: 500px;
  height: 500px;
  top: 50%;
  left: 33%;
  opacity: 0.2;
  animation-delay: -15s;
}

@keyframes blobMove {
  0% {
    transform: translate(0, 0) scale(1);
  }

  50% {
    transform: translate(5%, 10%) scale(1.1);
  }

  100% {
    transform: translate(-5%, 5%) scale(1);
  }
}

.hero-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--space-margin);
  position: relative;
  z-index: 10;
  width: 100%;
}

.hero-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border-radius: 1.5rem;
  padding: var(--space-md) var(--space-md);
}

.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: var(--space-xs);
  padding: 4px 12px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: var(--space-md);
  font-family: var(--font-label);
  font-size: 12px;
  color: var(--c-slate-200);
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.hero-badge-icon {
  font-size: 16px;
  color: var(--c-primary-fixed-dim);
  transform: scale(0.75);
}

.hero-title {
  font-family: var(--font-heading);
  font-size: 40px;
  font-weight: 700;
  margin-bottom: var(--space-md);
  max-width: 64rem;
  letter-spacing: -0.02em;
  line-height: 1.1;
  color: var(--c-white);
  text-shadow: 0 0 20px rgba(0, 82, 255, 0.5);
}

.hero-title-top {
  display: block;
  margin-bottom: 8px;
  font-size: 1.4em;
}

.hero-title-rotate {
  height: 1.2em;
  overflow: hidden;
  position: relative;
}

.scroll-text {
  display: flex;
  flex-direction: column;
  animation: scrollText 5s infinite;
}

.scroll-text span {
  display: block;
  padding: 4px 0;
  background: linear-gradient(to right, #0052ff, #70a1ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@keyframes scrollText {

  0%,
  25% {
    transform: translateY(0);
  }

  33.33%,
  58.33% {
    transform: translateY(-25%);
  }

  66.66%,
  91.66% {
    transform: translateY(-50%);
  }

  100% {
    transform: translateY(-75%);
  }
}

.hero-desc {
  font-size: 18px;
  line-height: 1.6;
  color: var(--c-slate-400);
  max-width: 42rem;
  margin-bottom: var(--space-lg);
}

.hero-actions {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  width: 100%;
}

.app-download-action {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 248px;
}

.btn-app-download {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 67px;
  box-sizing: border-box;
  padding: 12px 16px;
  color: var(--c-white);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  font-family: var(--font-heading);
  cursor: pointer;
  transition: all 0.3s;
}

.btn-app-download:hover {
  border-color: rgba(147, 197, 253, 0.7);
  background: rgba(255, 255, 255, 0.16);
  box-shadow: 0 18px 36px rgba(30, 64, 175, 0.2);
  transform: translateY(-4px);
}

.app-download-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 34px;
  height: 34px;
  color: #bfdbfe;
  border-radius: 10px;
  background: rgba(96, 165, 250, 0.18);
  font-size: 19px;
}

.app-download-copy {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 3px;
  text-align: left;
}

.app-download-copy strong {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
}

.app-download-copy small {
  color: var(--c-slate-400);
  font-family: var(--font-body);
  font-size: 11px;
  line-height: 1.2;
}

.app-download-arrow {
  margin-left: auto;
  color: #93c5fd;
  font-size: 16px;
}

.btn-start {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-base);
  background: var(--c-primary-container);
  color: var(--c-white);
  border: none;
  padding: 22px 34px;
  border-radius: 10px;
  font-family: var(--font-heading);
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
}

.btn-start:hover {
  box-shadow: 0 25px 50px -12px rgba(0, 82, 255, 0.4);
  transform: translateY(-4px);
}

.btn-icon {
  font-size: 24px;
}

.btn-start .btn-icon {
  color: inherit;
}

@media (min-width: 640px) {
  .hero-actions {
    flex-direction: row;
    justify-content: center;
  }

  .hero-title {
    font-size: 56px;
  }

  .hero-card {
    padding: var(--space-lg) var(--space-xl);
  }
}

/* ===== Marquee ===== */
.marquee-wrap {
  margin-top: var(--space-lg);
  width: 100%;
  overflow: hidden;
  mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);
  -webkit-mask-image: linear-gradient(to right, transparent, black 15%, black 85%, transparent);
}

.marquee-track {
  display: flex;
  gap: var(--space-md);
  animation: marquee 40s linear infinite;
  width: max-content;
}

.marquee-track:hover {
  animation-play-state: paused;
}

.marquee-row {
  display: flex;
  gap: var(--space-md);
}

.marquee-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  padding: 38px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.marquee-icon {
  font-size: 26px;
  color: var(--c-primary-fixed-dim);
  margin-bottom: var(--space-base);
}

.marquee-label {
  font-family: var(--font-heading);
  font-size: 14px;
  font-weight: 600;
  color: var(--c-white);
  margin: 0;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* ===== Sections ===== */
.section {
  padding: 40px 0;
  position: relative;
  z-index: 10;
}

.section-features {
  background: var(--c-mid);
}

.section-bento {
  background: var(--c-deep);
}

.section-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 var(--space-margin);
}

.section-header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: var(--space-xl);
  gap: var(--space-md);
}

.section-header-text {
  max-width: 36rem;
}

.section-title {
  font-family: var(--font-heading);
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--c-white);
  margin: 0 0 var(--space-sm) 0;
}

.section-desc {
  color: var(--c-slate-400);
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.section-divider {
  height: 1px;
  flex-grow: 1;
  background: rgba(255, 255, 255, 0.1);
  display: none;
}

@media (min-width: 768px) {
  .section-header {
    flex-direction: row;
  }

  .section-divider {
    display: block;
    margin-left: var(--space-lg);
  }
}

/* ===== Features ===== */
.features-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-gutter);
}

.feature-card {
  padding: var(--space-lg);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.3s;
}

.feature-card:hover {
  background: rgba(255, 255, 255, 0.1);
}

.feature-card-raised {
  transform: translateY(0);
}

@media (min-width: 768px) {
  .features-grid {
    grid-template-columns: repeat(3, 1fr);
  }

  .feature-card-raised {
    transform: translateY(var(--space-base));
  }
}

.feature-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--space-md);
  transition: background 0.3s;
}

.feature-card:hover .feature-icon-wrap {
  filter: brightness(1.1);
}

.feature-icon-0 {
  background: rgba(0, 82, 255, 0.2);
}

.feature-icon-1 {
  background: rgba(96, 165, 250, 0.2);
}

.feature-icon-2 {
  background: rgba(0, 82, 255, 0.2);
}

.feature-icon {
  font-size: 32px;
  color: var(--c-primary-fixed-dim);
}

.feature-title {
  font-family: var(--font-heading);
  font-size: 28px;
  font-weight: 600;
  color: var(--c-white);
  margin: 0 0 var(--space-base) 0;
}

.feature-desc {
  color: var(--c-slate-400);
  font-size: 18px;
  line-height: 1.6;
  margin: 0 0 var(--space-md) 0;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.feature-list-item {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  font-family: var(--font-label);
  font-size: 14px;
  color: var(--c-slate-300);
  letter-spacing: 0.05em;
}

.feature-check {
  font-size: 16px;
  color: var(--c-primary-fixed-dim);
  transform: scale(0.75);
}

/* ===== Bento ===== */
.bento-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-gutter);
}

.bento-card {
  border-radius: 12px;
  padding: var(--space-lg);
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.bento-card-large {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  position: relative;
}

.bento-content {
  position: relative;
  z-index: 10;
}

.bento-title {
  font-family: var(--font-heading);
  font-size: 32px;
  font-weight: 600;
  line-height: 1.3;
  color: var(--c-white);
  margin: 0 0 var(--space-sm) 0;
}

.bento-desc {
  color: var(--c-slate-400);
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.bento-terminal {
  margin-top: var(--space-lg);
  background: rgba(0, 0, 0, 0.4);
  border-radius: 8px;
  padding: var(--space-md);
  border: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 10;
}

.terminal-dots {
  display: flex;
  gap: var(--space-sm);
  margin-bottom: var(--space-sm);
}

.dot-red,
.dot-yellow,
.dot-green {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.dot-red {
  background: var(--c-error);
}

.dot-yellow {
  background: #f9bc05;
}

.dot-green {
  background: #34a853;
}

.terminal-lines {
  display: flex;
  flex-direction: column;
  gap: var(--space-base);
}

.line {
  height: 8px;
  border-radius: 9999px;
}

.line-w75 {
  width: 75%;
  background: rgba(255, 255, 255, 0.1);
}

.line-w50 {
  width: 50%;
  background: rgba(255, 255, 255, 0.05);
}

.line-w83 {
  width: 83%;
  background: rgba(0, 82, 255, 0.2);
}

.bento-glow {
  position: absolute;
  right: -80px;
  bottom: -80px;
  width: 256px;
  height: 256px;
  background: rgba(0, 82, 255, 0.1);
  border-radius: 50%;
  filter: blur(64px);
}

.bento-stats {
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 12px;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: var(--space-lg);
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-family: var(--font-heading);
  font-size: 48px;
  font-weight: 700;
  color: var(--c-primary-container);
  line-height: 1.2;
}

.stat-label {
  font-family: var(--font-label);
  font-size: 14px;
  color: var(--c-slate-300);
  letter-spacing: 0.05em;
}

.stat-divider {
  width: 1px;
  height: 48px;
  background: rgba(255, 255, 255, 0.1);
}

.bento-card-sm {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: background 0.3s;
}

.bento-card-sm:hover {
  background: rgba(255, 255, 255, 0.1);
}

.bento-sm-icon {
  font-size: 40px;
  color: var(--c-primary-container);
  margin-bottom: var(--space-base);
}

.bento-sm-title {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 600;
  color: var(--c-white);
  margin: 0;
}

@media (min-width: 768px) {
  .bento-grid {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 300px 300px;
  }

  .bento-card-large {
    grid-column: span 2;
    grid-row: span 2;
  }

  .bento-stats {
    grid-column: span 2;
  }

  .bento-card-sm {
    grid-column: span 1;
  }
}

/* ===== CTA ===== */
.cta-card {
  background: var(--c-primary-container);
  border-radius: 1rem;
  padding: var(--space-xl);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: var(--c-white);
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  position: relative;
}

.cta-pattern {
  position: absolute;
  inset: 0;
  opacity: 0.1;
  background-image: radial-gradient(circle at 2px 2px, white 1px, transparent 0);
  background-size: 40px 40px;
}

.cta-title {
  font-family: var(--font-heading);
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  margin: 0 0 var(--space-md) 0;
  position: relative;
  z-index: 10;
}

.cta-desc {
  font-size: 18px;
  line-height: 1.6;
  opacity: 0.9;
  max-width: 42rem;
  margin-bottom: var(--space-xl);
  position: relative;
  z-index: 10;
}

.btn-white {
  background: var(--c-white);
  color: var(--c-primary-container);
  border: none;
  padding: var(--space-md) var(--space-xl);
  border-radius: 12px;
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.3);
  position: relative;
  z-index: 10;
}

.btn-white:hover {
  transform: scale(1.05);
}

.cta-footnote {
  margin-top: var(--space-md);
  font-family: var(--font-label);
  font-size: 14px;
  letter-spacing: 0.05em;
  opacity: 0.7;
  position: relative;
  z-index: 10;
}

/* ===== Footer ===== */
.footer {
  background: var(--c-dark);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  position: relative;
  z-index: 10;
}

.footer-inner {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-gutter);
  max-width: 1280px;
  margin: 0 auto;
  padding: var(--space-lg) var(--space-margin);
}

.footer-logo-row {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
  margin-bottom: var(--space-sm);
}

.footer-name {
  font-family: var(--font-heading);
  font-size: 24px;
  font-weight: 600;
  color: var(--c-white);
}

.footer-copyright {
  font-family: var(--font-label);
  font-size: 12px;
  letter-spacing: 0.05em;
  color: var(--c-slate-400);
  max-width: 288px;
  margin: 0;
}

.footer-product-note {
  margin: 4px 0 0;
  color: var(--c-slate-400);
  font-family: var(--font-label);
  font-size: 12px;
}

.footer-product-link {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-product-link:hover {
  color: var(--c-white);
}

.footer-icp {
  display: inline-block;
  margin-top: 4px;
  color: var(--c-slate-400);
  font-family: var(--font-label);
  font-size: 12px;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-icp:hover {
  color: var(--c-white);
}

.footer-col {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.footer-col-title {
  font-family: var(--font-label);
  font-size: 14px;
  letter-spacing: 0.05em;
  font-weight: 700;
  color: var(--c-white);
  margin: 0;
}

.footer-link {
  font-family: var(--font-label);
  font-size: 12px;
  letter-spacing: 0.05em;
  color: var(--c-slate-400);
  text-decoration: none;
  transition: color 0.2s;
}

.footer-link:hover {
  color: var(--c-white);
}

/* ===== Light Theme ===== */
.theme-light .nav {
  background: rgba(246, 249, 253, 0.86);
  border-bottom-color: rgba(148, 163, 184, 0.22);
  box-shadow: 0 8px 28px rgba(15, 23, 42, 0.05);
}

.theme-light .nav-name,
.theme-light .nav-link-active,
.theme-light .nav-link:hover,
.theme-light .btn-text:hover {
  color: #172033;
}

.theme-light .nav-link,
.theme-light .btn-text {
  color: #64748b;
}

.theme-light .theme-toggle {
  border-color: #dbe4f0;
  background: rgba(255, 255, 255, 0.72);
  color: #475569;
}

.theme-light .theme-toggle:hover {
  border-color: #9dbbf7;
  background: #edf4ff;
  color: #1a73e8;
}

.theme-light .hero-bg {
  background: linear-gradient(145deg, #f5f8fc 0%, #eaf1fb 55%, #f2f5fa 100%);
}

.theme-light .blob { opacity: 0.24; filter: blur(120px); }
.theme-light .blob-1 { background: #93c5fd; }
.theme-light .blob-2 { background: #bfdbfe; }
.theme-light .blob-3 { background: #dbeafe; }
.theme-light .blob-4 { background: #818cf8; opacity: 0.12; }
.theme-light .particle-dot { background: #4f8ee8; opacity: 0.18; }

.theme-light .hero-badge {
  border-color: rgba(26, 115, 232, 0.16);
  background: rgba(255, 255, 255, 0.66);
  color: #52627a;
  box-shadow: 0 8px 24px rgba(30, 64, 175, 0.06);
}

.theme-light .hero-badge-icon { color: #1a73e8; }
.theme-light .hero-title { color: #172033; text-shadow: none; }
.theme-light .hero-desc { color: #64748b; }

.theme-light .btn-app-download {
  color: #334155;
  border-color: rgba(100, 116, 139, 0.2);
  background: rgba(255, 255, 255, 0.78);
  box-shadow: 0 10px 24px rgba(51, 65, 85, 0.06);
}

.theme-light .btn-app-download:hover {
  border-color: rgba(59, 130, 246, 0.5);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 18px 36px rgba(30, 64, 175, 0.12);
}

.theme-light .app-download-mark {
  color: #1a73e8;
  background: #edf4ff;
}

.theme-light .app-download-copy small {
  color: #64748b;
}

.theme-light .app-download-arrow {
  color: #3b82f6;
}

.theme-light .marquee-card,
.theme-light .feature-card,
.theme-light .bento-card,
.theme-light .bento-stats {
  border-color: rgba(148, 163, 184, 0.2);
  background: rgba(255, 255, 255, 0.66);
  box-shadow: 0 14px 40px rgba(51, 65, 85, 0.06);
}

.theme-light .marquee-label,
.theme-light .section-title,
.theme-light .feature-title,
.theme-light .bento-title,
.theme-light .bento-sm-title {
  color: #1e293b;
}

.theme-light .marquee-icon,
.theme-light .feature-icon,
.theme-light .feature-check { color: #3b82f6; }
.theme-light .section-features { background: #edf2f8; }
.theme-light .section-bento { background: #f3f6fb; }
.theme-light .section-divider,
.theme-light .stat-divider { background: rgba(100, 116, 139, 0.2); }
.theme-light .section-desc,
.theme-light .feature-desc,
.theme-light .bento-desc { color: #64748b; }
.theme-light .feature-list-item,
.theme-light .stat-label { color: #52627a; }
.theme-light .feature-card:hover,
.theme-light .bento-card-sm:hover { background: rgba(255, 255, 255, 0.92); }

.theme-light .footer {
  border-top-color: rgba(148, 163, 184, 0.2);
  background: #e8eef6;
}

.theme-light .footer-name,
.theme-light .footer-col-title { color: #1e293b; }
.theme-light .footer-copyright,
.theme-light .footer-link,
.theme-light .footer-product-note,
.theme-light .footer-icp { color: #64748b; }
.theme-light .footer-link:hover { color: #1a73e8; }
.theme-light .footer-product-link:hover { color: #1a73e8; }
.theme-light .footer-icp:hover { color: #1a73e8; }

@media (min-width: 768px) {
  .footer-inner {
    grid-template-columns: repeat(4, 1fr);
  }
}

/* ===== Responsive helpers ===== */
.hide-mobile {
  display: none;
}

@media (min-width: 768px) {
  .hide-mobile {
    display: inline;
  }
}

@media (max-width: 640px) {
  .nav-inner {
    padding: 0 var(--space-md);
    height: 60px;
  }

  .nav-name {
    font-size: 18px;
  }

  .nav-logo {
    height: 28px !important;
    width: 28px !important;
  }

  .nav-right {
    gap: var(--space-sm);
  }

  .btn-primary {
    padding: 6px 14px;
    font-size: 13px;
  }

  .btn-text {
    font-size: 13px;
  }

  .hero {
    padding-top: 80px;
    padding-bottom: 40px;
    min-height: auto;
  }

  .hero-card {
    padding: 20px 16px;
    border-radius: 1rem;
    background: none;
    backdrop-filter: none;
    -webkit-backdrop-filter: none;
    border: none;
    box-shadow: none;
  }

  .hero-badge {
    font-size: 11px;
    padding: 4px 10px;
    margin-bottom: var(--space-sm);
  }

  .hero-badge-icon {
    font-size: 14px;
  }

  .hero-title {
    font-size: 36px;
    margin-bottom: var(--space-sm);
  }

  .hero-title-top {
    margin-bottom: 4px;
  }

  .hero-desc {
    font-size: 15px;
    margin-bottom: var(--space-md);
  }

  .hero-actions {
    gap: 8px;
    flex-direction: column;
    align-items: stretch;
  }

  .app-download-action {
    align-items: stretch;
    min-width: 0;
  }

  .btn-start {
    font-size: 14px;
    padding: 18px 18px;
    border-radius: 8px;
    min-width: 0;
  }

  .btn-icon {
    font-size: 16px;
  }

  .hero-title-rotate {
    height: 1.1em;
  }

  .cta-title {
    font-size: 24px;
  }

  .cta-desc {
    font-size: 15px;
    margin-bottom: var(--space-md);
  }

  .cta-card {
    padding: var(--space-lg) var(--space-md);
  }

  .btn-white {
    font-size: 16px;
    padding: var(--space-sm) var(--space-md);
  }

  .bento-title {
    font-size: 22px;
  }

  .section-title {
    font-size: 22px;
  }

  .section {
    padding: var(--space-lg) 0;
  }

  .section-inner {
    padding: 0 var(--space-md);
  }

  .feature-card {
    padding: var(--space-md);
  }

  .feature-title {
    font-size: 20px;
  }

  .feature-desc {
    font-size: 15px;
  }

  .footer-inner {
    padding: var(--space-md);
    grid-template-columns: 1fr 1fr;
    gap: var(--space-md);
  }

  .footer-brand {
    grid-column: 1 / -1;
  }

  .footer-copyright {
    font-size: 11px;
  }

  .marquee-card {
    min-width: 100px;
    padding: var(--space-sm) var(--space-md);
  }

  .marquee-label {
    font-size: 14px;
  }

  .marquee-icon {
    font-size: 20px;
    margin-bottom: 4px;
  }

  .marquee-wrap {
    margin-top: calc(var(--space-md) + 10px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue